/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-08-29 18:06:30
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-09-12 14:25:32
 * @FilePath: \cubc-msc-vue\src\utils\http.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/* eslint-disable eqeqeq */
import axios from 'axios'
import { Message } from 'element-ui';
//===========>这个是匹配 接口URL <==================
const envConfig = {
        pro: {
            // 生产环境
            VUE_APP_API: 'cubcmsc.deppon.com.cn/cubc-msc-web/',
            type: 'pro'
        },
        dev: {
            // 本地开发环境  10.226.64.234:8127 联调 本地环境
            // VUE_APP_API: 'cubcmsc.deppontest.com/cubc-msc-web/',
            VUE_APP_API: '10.224.171.107:8082/cubc-msc-web/',
            type: 'dev'
        },
        dev2: {
            // 本地ip环境  10.226.64.234:8127  联调 测试环境
            VUE_APP_API: 'cubcmsc.deppontest.com/cubc-msc-web/',
            type: 'dev2'
        },
        sit: {
            VUE_APP_API: 'cubcmsc.deppontest.com/cubc-msc-web/', // 测试环境
            type: 'sit'
        }
    }
    //================>这个是匹配   前端项目启动的URL <==================
function getEnv() {
    const host = window.location.host
    if (host.match(/^localhost/i)) {
        return 'dev'
    // } else if (host.match(/^10.226.3.79/i)) { // 匹配 本地的 ip
    } else if (host.match(/^cubcmscfrontdev.deppontest/i)) { // 匹配 本地的 ip
        return 'dev2'
    } else if (host.match(/^cubcmsc.deppontest/i)) { // 匹配 测试的 ip
        return 'sit'
    } else if (host.match(/^cubcmsc.deppon.com.cn/i)) { // 匹配 生产的 ip
        return 'pro'
    }
}

// console.log(window.sessionStorage.getItem('token'))
var config = envConfig[getEnv()]
var protocol = location.protocol

const baseURL = protocol + '//' + config.VUE_APP_API

axios.defaults.timeout = 7000
axios.defaults.baseURL = baseURL
axios.defaults.headers.post['Content-Type'] = 'application/json'
    // http 请求拦截器
axios.interceptors.request.use(
    (config) => {
        removePending(config) // 在请求开始前，对之前的请求做检查取消操作
        addPending(config) // 将当前请求添加到 pending 中
        let token = window.localStorage.getItem('token');
        // let token = 'msc-web-session-c98b12d8-c8c2-4798-9f8e-1d4399f0540e';
         config.headers.token = token;
        return config
    },
    (error) => {
        return Promise.error(error)
    }
)

/**
 * 添加请求
 * @param {Object} config
 */
const addPending = (config) => {
    const url = [
        config.method,
        config.url,
        JSON.stringify(config.params),
        JSON.stringify(config.data)
    ].join('&')
    config.cancelToken = config.cancelToken || new axios.CancelToken(cancel => {
        if (!pending.has(url)) { // 如果 pending 中不存在当前请求，则添加进去
            pending.set(url, cancel)
        }
    })
}
/**
 * 移除请求
 * @param {Object} config
 */
const removePending = (config) => {
    const url = [
        config.method,
        config.url,
        JSON.stringify(config.params),
        JSON.stringify(config.data)
    ].join('&')
    if (pending.has(url)) { // 如果在 pending 中存在当前请求标识，需要取消当前请求，并且移除
        const cancel = pending.get(url)
        cancel(url)
        pending.delete(url)
    }
}
export const pending = new Map()
// http 响应拦截器
axios.interceptors.response.use(response => {
        removePending(response) // 在请求结束后，移除本次请求
        if (response.status === 200) {
            return Promise.resolve(response)
        }
    },
    error => { // 这里对 error 预期结果是包含具体错误信息和状态码
        if (error && error.response && error.response.status) {
            let errMesssge = error.response.data;
            if (error.config.responseType == "arraybuffer") {
                // 判断请求类型 转换后端传递的错误提示
                errMesssge = decodeURIComponent(escape(String.fromCharCode.apply(null, new Uint8Array(errMesssge))))
            }
            // 500 以上系统异常不弹窗告知
            if (error.response.status >= 500) {
                console.log(error.response.status + " 服务器崩溃 请稍后重试");
                return;
            }

            switch (error.response.status) {
                case 500:
                    // do something...
                    // Message({
                    //   showClose: true,
                    //   message: "服务器崩溃 请稍后重试",
                    //   type: "error",
                    //   offset: 300,
                    // });
                    console.log("服务器崩溃 请稍后重试");
                    return
                case 409:
                    // do something...
                    Message({
                        showClose: true,
                        message: "登录信息过期，请重新登录",
                        type: "error",
                        offset: 300,
                    });
                    localStorage.clear();
                    window.location.href = "https://www.deppon.com"
                    return
                case 404:
                    // do something...
                    return
                case 400:
                    Message({
                        showClose: true,
                        message: errMesssge,
                        type: "error",
                        offset: 300,
                    });
                    // do something...
                    return
                case 202:
                    // do something...
                    return
                case 415:
                    // do something...
                    return
                default:
                    // do something...
                    return
            }
        }
        return Promise.resolve(error.response)
    })




// axios.interceptors.response.use(
//   (response) => {
//     console.log(111,response);
//     // if(response.config.url=='statements/downloadFile'||response.status == 202){
//     //   console.log('请求202');
//     // }
//     // console.log(response,'response');
//     // console.log(response.status,'response.status');
//     // if(response.status == 400){
//     //   this.$message({
//     //     message: '下载成功',
//     //     type: 'success'
//     //   });
//     // }
//     return response
//   },
//   (error) => {
//     console.log(2222);
//     console.log(error,'aaaa');
//     if (error.status == 500) {
//       Message({
//         showClose: true,
//         message: "服务器崩溃 请稍后重试",
//         type: "error",
//         offset: 300,
//       });
//       return
//     }
//     return Promise.reject(error.response)
//   }
// )

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then((res) => {
            if(typeof res === 'undefined'){
                return
            }else {
                resolve(res.data)
            }
        }).catch((err) => {
            reject(err)
        })
    })
}
// 下载
export function getLonde(url, params) {
    return new Promise((resolve, reject) => {
        axios({
            timeout: 0,
            responseType: 'arraybuffer',
            method: 'post',
            url: url,
            data: params
        }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url, data).then((res) => {
            if(typeof res === 'undefined'){
                return
            }else {
                resolve(res.data)
            }
        }).catch((err) => {
            reject(err)
        })
    })
}
export { baseURL }